<app-loader></app-loader>
<router-outlet></router-outlet>
<p-confirmDialog
  [baseZIndex]="10000"
  acceptIcon="pi pi-check"
  rejectIcon="pi pi-times">
</p-confirmDialog>


@if (loadingService.apiLoader) {
  <div class="progress-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<p-toast position="top-right"></p-toast>